class GlideGridPropsConverter {
  convert(props) {
    return {
      rows: props.rows,
      rawModels: props.rawModels,
      freezeColumns: {
        desktop: props.frozenColumnsCount?.desktop ?? 0,
        mobile: props.frozenColumnsCount?.mobile ?? 0
      },
      page: props.paging?.page,
      pageSize: props.paging?.pageSize,
      pageSizeOptions: props.paging?.pageSizeOptions,
      totalRows: props.paging?.rowCount,
      isTotalCountUnknown: props.paging?.isTotalCountUnknown,
      sortModel: props.sortModel?.sortModel,
      pinnedRow: props.pinnedRow,
      pinnedRawModel: props.pinnedRawModel,
      emptyMessage: props.emptyMessage,
      hidePagination: props.hidePagination,
      gridFullHeight: props.gridFullPage,
      maxVisibleRows: props.maxVisibleRows,
      hasBorder: props.hasBorder,
      selection: props.selection,
      isRowSelectable: props.isRowSelectable,
      onPageChange: props.onPageChange,
      onPageSizeChange: props.onPageSizeChange,
      onSortChange: props.onSortChange,
      onSelect: props.onSelect
    };
  }
}
export {
  GlideGridPropsConverter
};
//# sourceMappingURL=GlideGridPropsConverter.js.map
